const ServerHost = 'clslet.mygolf2u.com';
const ServerPort = 80;
const ServerProtocol = 'http';
export const GOOGLE_MAP_ANDROID_KEY = 'AIzaSyDpbMcldv1v_kgCI_yYQmO737_PbvueKqc';
export const GOOGLE_MAP_IOS_KEY = 'AIzaSyDpbMcldv1v_kgCI_yYQmO737_PbvueKqc';
const RoutePath = `${ServerProtocol}://${ServerHost}:${ServerPort}`;
export const Apiurl = {
  RoutePath: RoutePath,
  login: '/api/login',
  registerPlayer: '/rest/register/player',
  startpasswordreset: '/rest/startpasswordreset',
  resetPassword: '/rest/resetpassword',
  changePassword: '/rest/changepassword',
  playerMain: '/rest/main/player',
  getCountries: '/rest/countries',
  handicapSystems: '/rest/handicap/handicap-systems',
  // playerHandicapCalculations: '/rest/handicap/player-handicap-calculations',
  faqdetails: '/document/assets/faq.json',
  Contactusdetails: '/document/assets/contact-us.json',
  // competition base
  competitionBase: '/rest/competition/',
  getTeebox: '/rest/tee-boxes',
  searchPlayers: "/rest/players/search",
  // getPlayerHcpList: "/rest/handicap/player-handicap-calculations",
  getRecentClubs: "/rest/clubs/recent",
  getClubsNearby: "/rest/clubs/nearby",
  searchClubs: "/rest/clubs/search",
  getClubCourses: "/rest/club/courses",
  getPlayerPerformanceBase   :  "/rest/player/performance",
  getPlayerPerformanceDetails:  "/rest/player/performancedetail",
  getPlayerPerformanceChart  :  "/rest/player/performancechart",

};
